export function UrlExample({ template, highlight }: { template: string; highlight: string }) {
  const [before, after] = template.split(highlight);

  return (
    <span className="ml-0.5 rounded bg-gray-100 px-1 py-0.5 font-mono text-gray-600 text-xs">
      {before}
      <span className="font-medium text-indigo-600">{highlight}</span>
      {after}
    </span>
  );
}
